import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { routes } from "./app.routes";
import { AppCommonModule } from "./common/app-common.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { ErrorsModule } from "./errors/errors.module";
import { LayoutModule } from "./layout/layout.module";

@NgModule({
  imports: [
    AppCommonModule,
    DashboardModule,
    ErrorsModule,
    LayoutModule,
    RouterModule.forRoot(routes)
  ],
  declarations: [
    AppComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts